module.exports = __webpack_public_path__ + "static/media/bg1.38312e55.jpg";